import React from "react";
import { BsGithub, BsLinkedin, BsInstagram, BsYoutube } from "react-icons/bs";
import { SiLeetcode } from "react-icons/si";

const SocialMedia = () => {
  return (
    <div className="app__social">
      <div>
        <a href="https://www.linkedin.com/in/abhishek41/">
          <BsLinkedin />
        </a>
      </div>

      <div>
        <a href="https://github.com/AbhishekNayak-Programmer">
          <BsGithub />
        </a>
      </div>

      <div>
        <a href="https://leetcode.com/Abhishek_Nayak_/">
          <SiLeetcode />
        </a>
      </div>

      <div>
        <a href="https://www.youtube.com/channel/UCp9QFNsQ9ZuCUdVEBytP3Rg">
          <BsYoutube />
        </a>
      </div>

      <div>
        <a href="https://www.instagram.com/_t.i.g.e.r_143/">
          <BsInstagram />
        </a>
      </div>
    </div>
  );
};

export default SocialMedia;
